import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    tipoProblema: '',
    valorBloqueado: '',
    mensagem: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const params = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        params.append(key, value);
      });
      const response = await fetch('https://readdy.ai/api/form/d3pe39mvn82kpvfp3fsg', {
        method: 'POST',
        body: params,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      if (response.ok) {
        if (typeof window !== "undefined" && typeof (window as any).gtag_report_conversion === "function") {
          (window as any).gtag_report_conversion();
        }
        setSubmitStatus('success');
        setFormData({ nome: '', email: '', telefone: '', tipoProblema: '', valorBloqueado: '', mensagem: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleWhatsAppClick = () => {
    if (typeof window !== "undefined" && typeof (window as any).gtag_report_conversion === "function") {
      (window as any).gtag_report_conversion();
    }
    window.open(
      'https://wa.me/5512997213362?text=Ol%C3%A1%20Dr.%20Gabriel%2C%20vim%20pelo%20site%20e%20quero%20analisar%20meu%20caso%20de%20bloqueio%20judicial',
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <section id="contato" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-amber-600 text-xs font-bold uppercase tracking-widest mb-3">Fale conosco</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Solicite uma análise do seu caso
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            Preencha o formulário abaixo ou entre em contato diretamente pelo WhatsApp. O atendimento é personalizado e discreto.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contatos */}
          <div>
            <div className="bg-gray-50 p-8 rounded-2xl mb-6 border border-gray-100">
              <h3 className="text-xl font-bold text-gray-900 mb-6">Entre em contato conosco</h3>
              <div className="space-y-5">
                <div className="flex items-center gap-4">
                  <div className="w-11 h-11 flex items-center justify-center bg-green-100 rounded-full shrink-0">
                    <i className="ri-whatsapp-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 text-sm">WhatsApp</p>
                    <p className="text-gray-500 text-sm">(12) 99721-3362</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-11 h-11 flex items-center justify-center bg-sky-100 rounded-full shrink-0">
                    <i className="ri-mail-line text-sky-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 text-sm">E-mail</p>
                    <p className="text-gray-500 text-sm">dr.araujo.gabriel@gmail.com</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-11 h-11 flex items-center justify-center bg-pink-100 rounded-full shrink-0">
                    <i className="ri-instagram-line text-pink-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 text-sm">Instagram</p>
                    <p className="text-gray-500 text-sm">@dr.araujogabriel</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-11 h-11 flex items-center justify-center bg-amber-100 rounded-full shrink-0">
                    <i className="ri-award-line text-amber-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 text-sm">OAB/SP</p>
                    <p className="text-gray-500 text-sm">433.002</p>
                  </div>
                </div>
              </div>
              <button
                onClick={handleWhatsAppClick}
                className="w-full mt-8 bg-green-600 hover:bg-green-700 text-white px-6 py-4 rounded-full font-semibold transition-colors duration-200 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                Falar Agora pelo WhatsApp
              </button>
            </div>
          </div>

          {/* Formulário */}
          <div>
            <form
              onSubmit={handleSubmit}
              className="bg-gray-50 p-8 rounded-2xl border border-gray-100"
              data-readdy-form
              id="contato-advocacia"
            >
              <h3 className="text-xl font-bold text-gray-900 mb-6">Formulário de Contato</h3>

              <div className="grid md:grid-cols-2 gap-5 mb-5">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-2">Nome Completo *</label>
                  <input
                    type="text"
                    name="nome"
                    value={formData.nome}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent text-sm"
                    placeholder="Seu nome completo"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-2">E-mail *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent text-sm"
                    placeholder="seu@email.com"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-5 mb-5">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-2">Telefone/WhatsApp *</label>
                  <input
                    type="tel"
                    name="telefone"
                    value={formData.telefone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent text-sm"
                    placeholder="(11) 99999-9999"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-2">Origem do Bloqueio</label>
                  <select
                    name="tipoProblema"
                    value={formData.tipoProblema}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent text-sm"
                  >
                    <option value="">Selecione...</option>
                    <option value="Execução Fiscal">Execução Fiscal</option>
                    <option value="Ação Trabalhista">Ação Trabalhista</option>
                    <option value="Cumprimento de Sentença">Cumprimento de Sentença</option>
                    <option value="Execução de Título">Execução de Título Extrajudicial</option>
                    <option value="Cobrança Judicial">Cobrança Judicial</option>
                    <option value="Não sei a origem">Não sei a origem</option>
                  </select>
                </div>
              </div>

              <div className="mb-5">
                <label className="block text-xs font-semibold text-gray-700 mb-2">Valor Aproximado Bloqueado</label>
                <input
                  type="text"
                  name="valorBloqueado"
                  value={formData.valorBloqueado}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent text-sm"
                  placeholder="Ex: R$ 15.000,00"
                />
              </div>

              <div className="mb-6">
                <label className="block text-xs font-semibold text-gray-700 mb-2">Descreva seu caso</label>
                <textarea
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={handleInputChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent text-sm resize-none"
                  placeholder="Conte-nos mais detalhes sobre o bloqueio..."
                ></textarea>
                <p className="text-xs text-gray-400 mt-1">{formData.mensagem.length}/500 caracteres</p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting || formData.mensagem.length > 500}
                className="w-full bg-amber-500 hover:bg-amber-400 disabled:bg-gray-300 text-gray-900 px-6 py-4 rounded-full font-bold text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Enviando...' : 'Solicitar Análise Jurídica'}
              </button>

              {submitStatus === 'success' && (
                <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                  <p className="text-green-800 text-sm">✅ Mensagem enviada! Entraremos em contato em breve.</p>
                </div>
              )}
              {submitStatus === 'error' && (
                <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                  <p className="text-red-800 text-sm">❌ Erro ao enviar. Tente pelo WhatsApp.</p>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
